// src/components/voices/DefaultVoiceList.tsx
/**
 * DefaultVoiceList Component
 *
 * Displays a grid of DefaultVoiceCard components for all
 * pre-made ElevenLabs voices.
 */

import { DefaultVoiceCard } from './DefaultVoiceCard';
import type { IDefaultVoice } from '@/@types/voices';

// ============================================================================
// Component
// ============================================================================

function DefaultVoiceList({
  voices,
  selectedVoiceId,
  onSelectVoice,
}: {
  voices: IDefaultVoice[];
  selectedVoiceId?: string | null;
  onSelectVoice?: (voiceId: string) => void;
}) {
  if (voices.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {voices.map(voice => (
        <DefaultVoiceCard
          key={voice.id}
          voice={voice}
          isSelected={selectedVoiceId === voice.id}
          onSelect={onSelectVoice}
        />
      ))}
    </div>
  );
}

export { DefaultVoiceList };
